
// This is generated on build. To change application config, change the files
// on ./app-config directory, and run the build again.
// Environment: production
// Brand: acom

const config = {
 "brand": "acom",
 "cookieDomain": ".americanas.com.br",
 "url": {
  "minhaconta": "",
  "login": "https://cliente.americanas.com.br/simple-login/",
  "cadastroPj": "https://cliente.americanas.com.br/simple-login/cadastro/pj/",
  "home": "https://www.americanas.com.br",
  "pagamento": "https://sacola.americanas.com.br/current-checkout/?#/payment/",
  "cadastroPf": "https://cliente.americanas.com.br/simple-login/cadastro/pf/",
  "guestRedirect": "https://minhaconta.americanas.com.br/#/orders/order/guest/",
  "associateShoppingClub": "https://cliente.americanas.com.br/simple-login/login-associado/",
  "privacyPolicy": "https://www.americanas.com.br/hotsite/politica-de-privacidade"
 },
 "api": {
  "customerv6": "https://sacola.americanas.com.br/api/v6/customer",
  "account": "https://sacola.americanas.com.br/api/v5/account",
  "restql": "https://sacola.americanas.com.br/api/v4/restql/run-query",
  "streamsCollector": "https://streams-collector-v1.b2w.io/event/site/page-visit",
  "customerv6NPF": "https://customer-v6-americanas.b2w.io",
  "customerToken": "https://sacola.americanas.com.br/api/v1/customer-token",
  "telemarketer": "https://sacola.americanas.com.br/api/v2/telemarketer-account",
  "guest": "https://sacola.americanas.com.br/api/v6/guest",
  "cep": " https://sacola.americanas.com.br/api/v3/cep",
  "spacey": "https://spacey-api-v2-americanas.b2w.io/spacey-api/publication/desktop/quantity-lock-warning/americanas",
  "shoppingClub": "https://customer-v6-americanas.b2w.io/customer/:customerId/shoppingclub",
  "finance": "https://sacola.americanas.com.br/api/v1/finance/segregation"
 },
 "b2wempresas": {
  "url": "https://empresas.americanas.com.br/"
 },
 "signUpScreen": {
  "errorMessages": {
   "blank": {
    "buyerName": "por favor, informe o nome e o sobrenome.",
    "buyerPhone": "é necessário informar o número do telefone.",
    "buyerEmail": "é necessário informar um e-mail.",
    "buyerPassword": "é necessário informar uma senha.",
    "cnpj": "é necessário informar um CNPJ.",
    "corporateName": "é necessário informar a razão social.",
    "fantasyName": "é necessário informar o nome fantasia.",
    "email": "é necessário informar um e-mail.",
    "zipCode": "é necessário informar o cep.",
    "city": "é necessário informar a cidade.",
    "address": "é necessário informar o endereço.",
    "number": "é necessário informar o número.",
    "neighborhood": "é necessário informar o bairro.",
    "phone": "é necessário informar o telefone empresarial.",
    "contactName": "é necessário informar o nome do contato de cobrança.",
    "stateRegistry": "é necessário informar a inscrição estadual."
   },
   "wrongFormat": {
    "buyerName": "por favor informe nome e sobrenome. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "buyerPhone": "obrigatório 11 números.",
    "buyerEmail": "preencha com o formato de email. Ex.: joaodasilva@gmail.com",
    "email": "preencha com o formato de email. Ex.: joaodasilva@gmail.com",
    "buyerPassword": "a senha precisa ter entre 6 e 20 caracteres.",
    "cnpj": "obrigatório conter 14 números. ",
    "corporateName": "permitido mínimo de 3 caracteres e no máximo 60 caracteres.",
    "fantasyName": "permitido mínimo de 3 caracteres e no máximo 60 caracteres.",
    "state": "obrigatório conter 2 letras.",
    "city": "permitido mínimo de 3 caracteres e no máximo 47 caracteres. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "address": "permitido mínimo de 3 caracteres e no máximo 60 caracteres. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "number": "permitido mínimo de 1 caracteres e no máximo 5 caracteres. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "neighborhood": "permitido mínimo de 3 caracteres e no máximo 47 caracteres. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "reference": "permitido mínimo de 3 caracteres e no máximo 47 caracteres. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "additionalInfo": "permitido mínimo de 3 caracteres e no máximo 47 caracteres. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "phone": "permitido 10 números se for telefone fixo, permitido 11 números se for celular.",
    "contactName": "por favor informe nome e sobrenome. não é permitido uso de caracteres especiais (-, @, #, ., etc)",
    "phoneExtensionRegistry": "permitido no máximo 5 números. somente números."
   }
  },
  "buyer": {
   "formTitle": "cadastre-se",
   "requiredFields": "campos obrigatórios",
   "passwordHelp": "precisa ter entre 6 e 20 caracteres (pelo menos 1 número, 1 caracter especial e 1 letra maiúscula)",
   "buttonSubmit": "continuar",
   "goBack": "voltar"
  },
  "company": {
   "formTitle": "cadastre a Empresa",
   "formSubtitle": "Forneça informações de acordo com seus documentos da receita federal e CEP dos correios.",
   "formBottomSubtitle": "Preencha os campos obrigatórios para continuar o cadastro",
   "buttonSubmit": "cadastrar",
   "goBack": "voltar"
  }
 },
 "enableGoogleLogin": false,
 "enableFacebookLogin": false,
 "enableLoginWithoutCaptcha": false,
 "captchaSite": "6Lecgi4UAAAAADoy8olZEoD8T5dqynjjJajXSQHj",
 "captchaLoadTimeout": 2500,
 "brandNumber": 2,
 "brandName": "americanas",
 "fromBrandName": "da americanas.com",
 "atBrandName": "na americanas.com",
 "queryname": {
  "customerAndRegionAndPrime": "/customerAndRegionAndPrime/4"
 },
 "finance": {
  "imageBrandCard": "./img/cartao-acom.png",
  "finance_title": "cartão americanas.com Visa",
  "finance_subtitle": "vantagens pra você sorrir ainda mais :)",
  "first_message": "descontos ainda maiores",
  "second_message": "mais limite para compras parceladas na americanas.com",
  "third_message": "parcelamento diferenciado",
  "fourth_message": "mais sorrisos: junte pontos e troque por vales-presente"
 },
 "googleAppId": "887697563888-uo5s3i3jhmc4g7rgr20rk43lqn2uco21.apps.googleusercontent.com",
 "hotjarSiteId": 369648,
 "allowHotjar": false,
 "enableCaptchaOnRegister": true,
 "enableCaptchaOnPJRegister": false,
 "enableCaptchaOnLogin": true,
 "enableCaptchaOnChangePassword": true,
 "enableCaptchaOnChangeLogin": true,
 "env": "production"
}

export default config
